<template>
    <div class="company-index">
        <div class="company-about-img">
            <el-image
                    style="width: 100%; height: 100%"
                    :src="require('@/assets/images/about.jpg')"
                    fit="cover"></el-image>
            <div class="company-info">
                <div>
                    <div class="company-info_name">浙江腾宇物联科技有限公司</div>
                    <p class="company-desc">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;浙江腾宇物联科技有限公司成立于2020年11月,是一家集物联网技术研发，
                        物联网技术服务 ，物联网应用服务，人工智能基础软件开发，
                        人工智能 理论与算法软件开发，人工智能应用软件开发,
                        人工智能行业应用系统集成服务等于一体的科技公司。
                        本公司拥有先进的技术支持，超前的设计理念和强 大的员工团队。
                        公司始终秉承“诚信求实、创新发展”的企业精神，持续深耕于智能物联行业，
                        以匠人精神做好产品与服务，以优质的产品与服务去赢 得越来越多客户与市场的认同。
                        公司自成立以来，坚持以客户需求为导向，始终将品质可靠、技术领先作为核心竞争力去打造，
                        高度重视并且持续加大 研发投入。
                    </p>
                    <p class="company-desc">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司目前主要经营的业务为数智无人酒店，旗下“腾宇慧住”APP为目前主要发展项目。
                        我们的酒店运营云服务平台是对酒店进行集群化经营和管理
                        这个平台可直接控制由我们公司提供的系列智能产品武装起来的成千上万家酒店。
                        目前参与研发的团队共15人：嵌入式软件工程师2人，计算机软件工程 师10人，
                        电子工程师2人，机械工程师1人。其中两位是计算机硕士研究生，其余全是本科。
                        “腾宇慧住”APP是一款线上订房，提供智能化入住的订房A PP，其中包括但不限于：
                        酒店订房、钟点房预定、民宿预定、海外订房、入住后客房智能控制等功能。
                        对酒店实行全方位数字化管理，是一个具有前景 符合目前时代发展，
                        且能给用户带来方便快捷的入住体验的现代化科技产品。腾宇物联系列智能产品、
                        智能系统云服务平台已运行多年，技术非常成熟， 系统非常稳定；酒店运营云服务平台、
                        酒店管理软件系统和订房APP，现在已经广泛应用在市场上。
                    </p>
                    <p class="company-desc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司今后的发展战略方向主要由以前的研发、生产和销售型为主转为未来的研发、服务和经融型为主。</p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'intr',
        data() {
            return {}
        }

    }
</script>

<style>
    .company-index {
        width: 100%;
        min-width: 900px;
        padding-top: 70px;
        position: relative;
    }

    .company-about-img {
        width: 100%;
        height: 700px;
    }

    .company-info {
        width: 100%;
        min-width: 900px;
        display: flex;
        justify-content: center;
        z-index: 100;
        position: absolute;
        top: 0;
        left: 0;
        padding-top: 200px;
        background: rgba(0, 0, 0, 0.4);
        height: 570px;
    }

    .company-info_name {
        width: 70%;
        font-size: 50px;
        color: #ffffff;
        font-weight: bold;
        margin-bottom: 30px;
    }

    .company-desc {
        text-align: left;
        width: 70%;
        margin: auto;
        color: #ffffff;
        font-size: 18px;
        line-height: 30px;
    }

</style>